import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../../../../group_leader/components/common'
import { makeT } from '../../../../group_leader/helpers/i18n'

const t = makeT('group_leader.event_setup.players.sources')

// Where golfers come from; no counts, as neither list is loaded when the tiles paint.
const SourceTiles = ({ active, onSelect, emptySources = {} }) => {
  // Search leads: the one source that needs no browsing.
  const tiles = [
    { key: 'search', icon: 'search' },
    { key: 'roster', icon: 'people' },
    { key: 'previous_event', icon: 'calendar' },
  ]

  return (
    <div className="gl-event-setup-source-tiles">
      {tiles.map((tile) => {
        // Disabled rather than opening onto an empty state; a screen reader says why.
        const empty = Boolean(emptySources[tile.key])

        return (
          <button
            key={tile.key}
            type="button"
            aria-pressed={active === tile.key}
            disabled={empty}
            title={empty ? t(`${tile.key}.empty`) : undefined}
            className={[
              'gl-event-setup-source-tile',
              active === tile.key ? 'gl-event-setup-source-tile--active' : '',
            ].filter(Boolean).join(' ')}
            onClick={() => onSelect(active === tile.key ? null : tile.key)}
          >
            <span className="gl-event-setup-source-tile-head">
              <span className="gl-event-setup-source-tile-icon"><Icon name={tile.icon} size={18}/></span>
              <span className="gl-event-setup-source-tile-label">{t(`${tile.key}.label`)}</span>
            </span>
            <span className="gl-event-setup-source-tile-desc">
              {empty ? t(`${tile.key}.empty`) : t(`${tile.key}.desc`)}
            </span>
          </button>
        )
      })}
    </div>
  )
}

SourceTiles.propTypes = {
  active: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  // Keyed by tile: true once that source is known to hold nothing.
  emptySources: PropTypes.objectOf(PropTypes.bool),
}

export default SourceTiles
